module.exports = __webpack_public_path__ + "img/2.58e34d2f.jpg";